module.exports = __webpack_public_path__ + "static/media/tips-link.39a2274d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/tips-link.png
// module id = 1963
// module chunks = 6